// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var InterTraderBtnStatus;
(function (InterTraderBtnStatus) {
    InterTraderBtnStatus[InterTraderBtnStatus["Closed"] = 0] = "Closed";
    InterTraderBtnStatus[InterTraderBtnStatus["Open"] = 1] = "Open";
    InterTraderBtnStatus[InterTraderBtnStatus["Call"] = 2] = "Call";
})(InterTraderBtnStatus || (InterTraderBtnStatus = {}));
